module.exports = __webpack_public_path__ + "img/ot2.971faa82.png";